export default __webpack_public_path__ + "static/main-poster-df95bb981281a4bc5ac00a0ef4cf5208.avif";